import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import MainLayout from "../../layout/MainLayout";

const UpdateAirContractForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    contractType: "",
    contractStartDate: "",
    contractEndDate: "",
    contractImage: null,
  });

  useEffect(() => {
    const fetchClient = async () => {
      try {
        const res = await axios.get(`https://globizsystems.click/api/air-client/${id}`);
        const client = res.data;
        setFormData({
          contractType: client.contractType || "",
          contractStartDate: client.contractStartDate
            ? client.contractStartDate.split("T")[0]
            : "",
          contractEndDate: client.contractEndDate
            ? client.contractEndDate.split("T")[0]
            : "",
          contractImage: null,
        });
      } catch (error) {
        console.error(error);
        Swal.fire("Ralat", "Gagal mendapatkan data pelanggan", "error");
      }
    };
    fetchClient();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value) form.append(key, value);
      });

      await axios.put(`https://globizsystems.click/api/air-client/${id}`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      Swal.fire("Berjaya!", "Maklumat kontrak berjaya dikemaskini.", "success");
      navigate("/summary"); // redirect back to list
    } catch (error) {
      console.error(error);
      Swal.fire("Ralat", "Gagal mengemaskini maklumat kontrak", "error");
    }
  };

  return (
    <MainLayout>
      <div className="p-4 md:p-8 flex justify-center">
        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-lg rounded-lg p-6 w-full max-w-md"
        >
          <h2 className="text-xl font-bold mb-4 text-center">
            Kemaskini Kontrak Air
          </h2>

          <label className="block mb-2 font-medium">Jenis Kontrak</label>
          <input
            type="text"
            name="contractType"
            value={formData.contractType}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Masukkan jenis kontrak"
          />

          <label className="block mb-2 font-medium">Tarikh Mula Kontrak</label>
          <input
            type="date"
            name="contractStartDate"
            value={formData.contractStartDate}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <label className="block mb-2 font-medium">Tarikh Tamat Kontrak</label>
          <input
            type="date"
            name="contractEndDate"
            value={formData.contractEndDate}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <label className="block mb-2 font-medium">Imej Kontrak</label>
          <input
            type="file"
            name="contractImage"
            accept="image/*"
            onChange={handleChange}
            className="w-full border rounded px-3 py-2 mb-4"
          />

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700"
          >
            Simpan Perubahan
          </button>
        </form>
      </div>
    </MainLayout>
  );
};

export default UpdateAirContractForm;
